/**
 * Query keys for digital products React Query hooks.
 * Centralized for consistent cache invalidation.
 */
export const DIGITAL_PRODUCTS_QUERY_KEY = "digital-products" as const;
export const DIGITAL_PRODUCT_QUERY_KEY = "digital-product" as const;
export const DIGITAL_PRODUCT_CONTENT_QUERY_KEY = "digital-product-content" as const;
export const DIGITAL_PRODUCT_INSIGHTS_QUERY_KEY = "digital-product-insights" as const;
export const DIGITAL_PRODUCT_PURCHASES_QUERY_KEY = "digital-product-purchases" as const;
export const DIGITAL_PRODUCT_ADDONS_QUERY_KEY = "digital-product-add-ons" as const;

export const digitalProductsQueryKeys = {
  all: [DIGITAL_PRODUCTS_QUERY_KEY] as const,
  lists: () => [...digitalProductsQueryKeys.all, "list"] as const,
  list: (params: {page: number; perPage: number}) =>
    [...digitalProductsQueryKeys.lists(), params] as const,
  details: () => [...digitalProductsQueryKeys.all, "detail"] as const,
  detail: (id: number) => [...digitalProductsQueryKeys.details(), id] as const,
  content: (productId: number) => [DIGITAL_PRODUCT_CONTENT_QUERY_KEY, productId] as const,
  insights: (productId: number) =>
    [DIGITAL_PRODUCT_INSIGHTS_QUERY_KEY, productId] as const,
  purchases: (productId: number, page: number) =>
    [DIGITAL_PRODUCT_PURCHASES_QUERY_KEY, productId, page] as const,
  addOns: (productId: number) => [DIGITAL_PRODUCT_ADDONS_QUERY_KEY, productId] as const,
};
